import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Categoria } from './categoria.model';

@Injectable({
  providedIn: 'root'
})
export class CategoriaService {
  listCategoria:Categoria[];
  categoria:Categoria;
  private routeApi = "AdmCategorias";
  constructor(
    private generalHttp:GeneralHttpService
  ) { }


  getCategoria(){
    this.generalHttp.getHttp(this.routeApi).then(r => this.listCategoria = r as Categoria[]);
  }


  getCategoriaByIdTipo(id:number){
    return this.generalHttp.getHttpById(id,this.routeApi + "/ByIdTipo").then(r => this.listCategoria = r as Categoria[]);
  }


  postCategoria(form:Categoria){
    return this.generalHttp.postHttp(form,this.routeApi)
  }


  putCategoria(form:Categoria,id:number){
    return this.generalHttp.putHttp(form,id,this.routeApi)
  }

  deleteCategoria(id:number){
    return this.generalHttp.deleteHttp(id,this.routeApi);
  }

  getCategoryTypeNoveltyModifySlip() {
    return this.generalHttp.getHttp(`${this.routeApi}/getCategoryBySlipModify`);
  }

}

